import React, { memo, useContext, useCallback, useState } from 'react';
import { View, FlatList } from 'react-native';
import { isAfter, startOfQuarter, setYear, setQuarter, parseISO, } from 'date-fns';
import { rem } from 'design-system/values';
import { Button } from 'design-system/Button';
import { CardView } from 'design-system/CardView';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import ContentHeader from '../../calendar/ContentHeader';
import { AnalyticsFilterContext } from '../context';
import SelectorWithButtons from '../SelectorWithButtons';
import { quartersArr, filterStartYear } from '../constants';
import { isWeb } from '../../../constants';
const QuarterlyContent = () => {
    const styles = useStyles(styleSet);
    const { currentYear, selectedYear, selectedQuarter, setSelectedYear, setSelectedQuarter, todayDateStr, } = useContext(AnalyticsFilterContext);
    const [calendarYear, setCalendarYear] = useState(selectedYear);
    const changeYear = useCallback((decrease) => () => {
        if (decrease) {
            if (calendarYear > filterStartYear) {
                setCalendarYear(calendarYear - 1);
            }
            return;
        }
        if (calendarYear < currentYear) {
            setCalendarYear(calendarYear + 1);
        }
    }, [currentYear, calendarYear, setCalendarYear]);
    const onPress = (index) => {
        setSelectedQuarter(index + 1);
        setSelectedYear(calendarYear);
    };
    return (<CardView style={styles.card}>
      <ContentHeader style={styles.header} title={selectedQuarter !== undefined
            ? `Q${selectedQuarter} ${calendarYear}`
            : ''}/>
      <SelectorWithButtons title={calendarYear} onForward={changeYear(false)} onBackward={changeYear(true)} disableForward={calendarYear === currentYear} disableBackward={calendarYear === filterStartYear}/>
      <FlatList numColumns={4} data={quartersArr} scrollEnabled={false} contentContainerStyle={styles.contentContainerStyles} columnWrapperStyle={styles.columnWrapperStyle} renderItem={({ item, index }) => (<View style={styles.eachButtonContainer}>
            <Button flex square title={item} disabled={calendarYear === currentYear &&
                isAfter(startOfQuarter(setYear(setQuarter(new Date(), index + 1), calendarYear)), parseISO(todayDateStr))} containerStyle={styles.buttonStyles} onPress={() => onPress(index)} {...(selectedQuarter === index + 1 &&
            selectedYear === calendarYear
            ? { brandTextBorder: true }
            : { gray: true })}/>
          </View>)}/>
    </CardView>);
};
export default memo(QuarterlyContent);
const styleSet = createStyleSheets((colors) => ({
    card: {
        ...(isWeb && {
            backgroundColor: colors.background.light,
        }),
    },
    header: {
        marginVertical: rem(16),
        marginHorizontal: rem(16),
    },
    columnWrapperStyle: {
        flex: 1,
    },
    eachButtonContainer: {
        flex: 1,
        margin: rem(8),
        height: rem(45),
    },
    contentContainerStyles: {
        padding: rem(8),
    },
    buttonStyles: {
        height: rem(45),
    },
}));
